import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.js-before-and-after-splide' ).length ) {
        $( '.js-before-and-after-splide' ).each( function( _index, element ) {
          const slider = new Splide( element, {
            type: 'slide',
            perPage: 1,
            pagination: false,
            gap: '20px',
            speed: 800,
            i18n: {
              prev: 'Previous project',
              next: 'Next project',
              slideX: 'Go to project %s',
              first: 'Go to first project',
              last: 'Go to last project',
            },
          } ).mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'before-and-after', COMPONENT );
} )( app );
